"use strict";

/*!
 * @Description: 滑动到底部时自动加载下一页数据
 * @Author: DahlZb
 * @Date: 2019-08-11 23:26:57
 * @LastEditTime: 2020-12-07 17:54:30
 * @LastEditors: Please set LastEditors
 * @Version 2.0.0
 */
;

(function ($, window, document, undefined) {
  var ScrollPage = function () {
    function ScrollPage(element, options) {
      this.v = "2.0.0"; // 私有默认参数

      var privateDefaults = {
        private: {
          lock: false,
          isOver: true,
          timer: 0
        }
      };
      this.defaults = $.extend(true, {}, $.fn.scrollPage.defaults, privateDefaults);
      this.settings = $.extend(true, {}, this.defaults, options);
      this.options = options;
      this.element = {
        $element: element // 当前控件

      };
      this.init();
    }

    ScrollPage.prototype = {
      init: function init() {
        var _self = this;

        _self.load();
      },
      load: function load() {
        var _self = this;

        var next = function next(isOver) {
          _self.settings.private.isOver = isOver;
          _self.settings.private.lock = null;
          if (typeof _self.settings.hideLoading === "function") _self.settings.hideLoading();

          if (isOver == true) {
            if (typeof _self.settings.showNoData === "function") _self.settings.showNoData();
          }
        };

        var done = function done() {
          _self.settings.private.lock = true;
          if (typeof _self.settings.showLoading === "function") _self.settings.showLoading();
          if (typeof _self.settings.done === 'function') _self.settings.done(_self.settings.pageIndex++, next);
        };

        done();
        $(_self.element.$element).off("scroll");
        $(_self.element.$element).on('scroll', function () {
          if (_self.settings.private.timer) clearTimeout(_self.settings.private.timer); //如果已经结束，或者元素处于隐藏状态，则不执行滚动加载

          if (_self.settings.private.isOver || !_self.element.$element.width()) return;
          _self.settings.private.timer = setTimeout(function () {
            // 文档的高度 + 顶部滑动距离 >= 内容高度
            if (_self.element.$element[0].clientHeight + _self.element.$element.scrollTop() >= _self.element.$element[0].scrollHeight - _self.settings.bottomDistance) {
              _self.settings.private.lock || done();
            }
          }, 100);
        });
      }
    };
    return ScrollPage;
  }(); //在插件中使用ScrollPage对象


  $.fn.scrollPage = function (options) {
    //创建ScrollPage的实体
    var scrollPage = new ScrollPage(this, options); //调用其方法

    return scrollPage;
  }; // 默认配置参数


  $.fn.scrollPage.defaults = {
    pageIndex: 1,
    // 当前页码，起始页码
    bottomDistance: 50,
    // 距离底部多高时，触发请求数据事件
    // 触发滑动到底部事件， pageIndex：当前页码，next：设置是否还有下一页
    done: function done(pageIndex, next) {// TODO 加载当前页数据到页面
      // isOver : 是否已结束，没有了下一页
      // next(isOver)
    },
    // 显示加载中 例如：显示Loading
    showLoading: function showLoading() {// comm.pageLoad.showLoading(self.settings.loading.showBoxEle);
    },
    // 隐藏加载中 例如：隐藏Loading
    hideLoading: function hideLoading() {// comm.pageLoad.hideLoading(self.settings.loading.showBoxEle);
    },
    // 显示无数据 例如：显示无数据
    showNoData: function showNoData() {// comm.pageLoad.showNoData(self.settings.loading.showBoxEle);
    }
  };
})(jQuery, window, document);